import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceSemicolonPesosGirsac'
})
export class ReplaceSemicolonPesosGirsacPipe implements PipeTransform {

  transform(value: string): any {
  
    let resultado="";
    
    if(value.charAt(value.length-1)==";"){
      resultado=value.substring(0,(value.length-1)).replace(/;/g,',');
    }else{
      resultado=value.replace(/;/g,',');
    }

    return resultado;
  }

}
